import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

export const getAllSuppliers = createAsyncThunk(
  "suppliers/getAllSuppliers",
  async ({ page = 1, limit = 50, buyerId }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const response = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management?page=${page}&limit=${limit}&buyerId=${buyerId}`,
        // `http://localhost:3006/api/supplier/management?page=${page}&limit=${limit}&buyerId=${buyerId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );
      return {
        suppliers: response.data.data,
        totalSuppliers: response.data.total,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error fetching suppliers");
    }
  }
);
export const getFilteredManagementSuppliers = createAsyncThunk(
  "suppliers/getFilteredManagementSuppliers",
  async ({ filters, page = 1, limit = 50, buyerId }, { rejectWithValue }) => {
    try {
      let normalizedFilters = {};

      if (filters) {
        normalizedFilters = Object.entries(filters).reduce(
          (acc, [key, value]) => {
            // const normalizedKey = key.toLowerCase();

            if (key === "certification") {
              // Only take the first value, assuming it's like ["Certified"] or ["Uncertified"]
              const certValue = Array.isArray(value) ? value[0] : value;

              acc["certificationStatus"] =
                certValue === "Certified"
                  ? true
                  : certValue === "Uncertified"
                  ? false
                  : undefined;
            } else {
              acc[key] = value;
            }

            return acc;
          },
          {}
        );
      }

      const response = await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/list?buyerId=${buyerId}`,
        normalizedFilters,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getSuppliersByFolder = createAsyncThunk(
  "suppliers/getSuppliersByFolder",
  async (
    { folderName, page = 1, limit = 50, buyerId },
    { rejectWithValue }
  ) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const encodedFolder = encodeURIComponent(folderName);

      const response = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/folder/${encodedFolder}?page=${page}&limit=${limit}&buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );

      return {
        folderName,
        suppliers: response.data.data,
        total: response.data.total,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch suppliers by folder"
      );
    }
  }
);

export const getFolderCountsByBuyerId = createAsyncThunk(
  "suppliers/getFolderCountsByBuyerId",
  async (buyerId, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const response = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/folder-counts/name`,
        // `http://localhost:3006/api/supplier/management/folder-counts/name`,
        {
          headers: {
            "x-api-key": apiKey,
          },
          params: {
            buyerId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch folder counts"
      );
    }
  }
);

export const createSupplier = createAsyncThunk(
  "suppliers/createSupplier",
  async (supplierInfo, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";
      // process.env.REACT_APP_MANAGEMENT_SUPPLIER_API_KEY;

      const response = await axios.post(
        "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/create",
        // "http://localhost:3006/api/supplier/management/create",
        supplierInfo,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error creating supplier");
    }
  }
);

export const uploadCSVWithMapping = createAsyncThunk(
  "suppliers/uploadCSVWithMapping",
  async ({ createdBy, file, map, addToFolder }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const formData = new FormData();
      formData.append("file", file);
      formData.append("map", JSON.stringify(map));
      formData.append("createdBy", createdBy);
      formData.append("addToFolder", addToFolder);

      const response = await axios.post(
        "https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/csv/upload",
        formData,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to upload CSV with mapping"
      );
    }
  }
);

export const editSupplierById = createAsyncThunk(
  "suppliers/editSupplierById",
  async ({ supplierId, updatedData, buyerId }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const response = await axios.patch(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/${supplierId}`,
        // `http://localhost:3006/api/supplier/management/${supplierId}`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error updating supplier");
    }
  }
);

export const deleteSupplieById = createAsyncThunk(
  "suppliers/deleteSupplier",
  async ({ supplierId, buyerId }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const response = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/${supplierId}?buyerId=${buyerId}`,
        // `http://localhost:3006/api/supplier/management/${supplierId}?buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );

      return { supplierId }; // You can return just the ID so it can be removed from state
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error deleting supplier");
    }
  }
);
export const bulkDeleteSuppliers = createAsyncThunk(
  "suppliers/bulkDeleteSuppliers",
  async ({ supplierIds, buyerId }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

      const response = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/bulk/delete?buyerId=${buyerId}`,
        // `http://localhost:3006/api/supplier/management/bulk/delete?buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
          data: { supplierIds },
        }
      );

      return { deletedIds: supplierIds };
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Error bulk deleting suppliers"
      );
    }
  }
);

export const sendRequestMessage = createAsyncThunk(
  "suppliers/sendRequestMessage",
  async ({ supplierId, message, buyerId }, { rejectWithValue }) => {
    try {
      const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";
      const response = await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/request-info/${supplierId}`,
        { message, buyerId },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPendingSuppliers = createAsyncThunk(
  "suppliers/fetchPendingSuppliers",
  async ({ buyerId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/status/pending?buyerId=${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editFolderName = createAsyncThunk(
  "folders/editFolderName",
  async (
    { createdBy, folderToEdit, newFolderName, buyerId },
    { rejectWithValue }
  ) => {
    try {
      const encodedFolderName = encodeURIComponent(folderToEdit);

      const response = await axios.patch(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/folder/${encodedFolderName}?buyerId=${buyerId}`,
        {
          // createdBy,
          newFolderName,
        },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteFolder = createAsyncThunk(
  "folders/deleteFolder",
  async ({ createdBy, folderName, buyerId }, { rejectWithValue }) => {
    try {
      const encodedFolderName = encodeURIComponent(folderName);
      const response = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/delete/folder/${encodedFolderName}/buyer/${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendInvite = createAsyncThunk(
  "supplier/sendInvite",
  async ({ supplierId, buyerId, message }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/send-invite/${supplierId}`,
        { message, buyerId },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to send invite"
      );
    }
  }
);

export const moveSupplierToFolder = createAsyncThunk(
  "suppliers/moveSupplierToFolder",
  async (
    { supplierId, buyerId, newFolderName },
    { dispatch, rejectWithValue }
  ) => {
    try {
      await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/supplier/management/folder/${supplierId}?buyerId=${buyerId}`,
        { newFolderName },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      await dispatch(getFolderCountsByBuyerId(buyerId));

      return { message: "Supplier moved successfully" };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const saveSupplierToBookmark = createAsyncThunk(
  "suppliers/saveSupplierToBookmark",
  async ({ buyerId, supplierId }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/v1/suppliers/save-supplier`,
        {
          buyerId,
          supplierId,
        },
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const getSavedSuppliers = createAsyncThunk(
  "suppliers/getSavedSuppliers",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/v1/suppliers/save-supplier/${buyerId}`,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteSavedSupplier = createAsyncThunk(
  "suppliers/deleteSavedSupplier",
  async ({ buyerId, supplierId }, { rejectWithValue }) => {
    try {
      const res = await axios.delete(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/v1/suppliers/save-supplier/${buyerId}/${supplierId}`,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );
      return { supplierId, message: res.data?.message };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

function countSuppliersByFolder(suppliers, folderName, total) {
  if (folderName === "Total Suppliers") return total;
  return suppliers?.filter((s) => s.folder?.name === folderName).length;
}

const folders = [
  { name: "Total Suppliers", numberOfSuppliers: 0, default: true },
  { name: "Tier 1", numberOfSuppliers: 0, default: true },
  { name: "Tier 2", numberOfSuppliers: 0, default: true },
  { name: "Tier 3", numberOfSuppliers: 0, default: true },
];

const initialState = {
  suppliers: [],
  filteredSuppliers: [],
  suppliersByFolder: [],
  pendingSuppliers: [],
  totalSuppliers: 0,
  totalPendingSuppliers: 0,
  // selectedSupplier: null,
  saved: [],
  folders: folders,
  loading: false,
  success: false,
  error: null,
  messageStatus: null,
};

const suppliersSlice = createSlice({
  name: "suppliers",
  initialState,
  reducers: {
    addSuppliers: (state, action) => {
      const newSuppliers = action.payload;
      state.suppliers.push(...newSuppliers);
    },
    // setSelectedSupplier: (state, action) => {
    //   state.selectedSupplier = action.payload;
    // },
    // clearSelectedSupplier: (state) => {
    //   state.selectedSupplier = null;
    // },

    updateSupplier: (state, action) => {
      const updatedSupplier = action.payload;

      state.suppliers = state.suppliers.map((supplier) =>
        supplier._id === updatedSupplier._id ? updatedSupplier : supplier
      );

      state.folders = state.folders.map((folder) => ({
        ...folder,
        numberOfSuppliers: countSuppliersByFolder(
          state.suppliers,
          folder.name,
          state.totalSuppliers
        ),
      }));
    },

    deleteSupplier: (state, action) => {
      const idToDelete = action.payload._id;
      const folderName = action.payload.folder?.name;
      const wasDeleted = state.suppliers.some(
        (supplier) => supplier._id === idToDelete
      );

      state.suppliers = state.suppliers.filter(
        (supplier) => supplier._id !== idToDelete
      );
      state.suppliersByFolder = state.suppliersByFolder.filter(
        (supplier) => supplier._id !== idToDelete
      );

      if (wasDeleted) {
        state.folders = state.folders.map((folder) => {
          if (folder.name === "Total Suppliers" || !folderName) {
            return {
              ...folder,
              numberOfSuppliers: Math.max(
                (folder.numberOfSuppliers || 0) - 1,
                0
              ),
            };
          }

          if (folder.name === folderName) {
            return {
              ...folder,
              numberOfSuppliers: Math.max(
                (folder.numberOfSuppliers || 0) - 1,
                0
              ),
            };
          }

          return folder;
        });
      }
    },

    setFolders: (state, action) => {
      state.folders = action.payload;
    },

    updateFolders: (state, action) => {
      const folderUpdates = action.payload;
      state.folders = state.folders.map((folder) => {
        const match = folderUpdates.find((f) => f.name === folder.name);
        return match ? { ...folder, ...match } : folder;
      });
    },
    updateFolderCounts: (state, action) => {
      const { folderName, count } = action.payload;
      state.folders = state.folders.map((folder) => {
        const isTargetFolder = folder.name === folderName;
        const isTotalFolder = folder.name === "Total Suppliers";

        if (isTargetFolder || isTotalFolder) {
          return {
            ...folder,
            numberOfSuppliers: (folder.numberOfSuppliers || 0) + count,
          };
        }

        return folder;
      });
    },
    setSuppliers: (state, action) => {
      state.suppliers = action.payload;
    },
    // saveSupplier: (state, action) => {
    //   const supplier = action.payload;
    //   const alreadySaved = state.saved.find((s) => s._id === supplier._id);
    //   if (!alreadySaved) {
    //     state.saved.push(supplier);
    //   }
    // },

    removeSavedSupplier: (state, action) => {
      const supplierId = action.payload;
      state.saved = state.saved.filter((s) => s._id !== supplierId);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllSuppliers.fulfilled, (state, action) => {
        const { suppliers, totalSuppliers } = action.payload;

        state.suppliers = suppliers;
        state.totalSuppliers = totalSuppliers;
        state.loading = false;
        state.error = null;
      })
      .addCase(saveSupplierToBookmark.fulfilled, (state, action) => {
        state.loading = false;
        const newSupplier = action.payload;
        const exists = state.saved.find((s) => s._id === newSupplier._id);
        if (!exists) state.saved.push(newSupplier);
      })
      .addCase(getSavedSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.saved = action.payload;
      })
      .addCase(deleteSavedSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.saved = state.saved.filter(
          (s) => s._id !== action.payload.supplierId
        );
      })
      .addCase(getFilteredManagementSuppliers.fulfilled, (state, action) => {
        state.filteredSuppliers = action.payload.data.suppliers;

        state.loading = false;
        state.error = null;
      })
      .addCase(getSuppliersByFolder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSuppliersByFolder.fulfilled, (state, action) => {
        const { folderName, suppliers } = action.payload;
        state.suppliersByFolder = suppliers;
        state.selectedFolder = folderName;
        state.loading = false;
      })
      .addCase(getSuppliersByFolder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error loading folder suppliers";
      })

      .addCase(createSupplier.pending, (state) => {
        state.createStatus = { loading: true, success: false, error: null };
      })
      .addCase(createSupplier.fulfilled, (state, action) => {
        const newSupplier = action.payload;
        state.suppliers.push(newSupplier);

        state.createStatus = { loading: false, success: true, error: null };
      })
      .addCase(createSupplier.rejected, (state, action) => {
        state.createStatus = {
          loading: false,
          success: false,
          error: action.payload || "Unknown error",
        };
      })
      .addCase(getFolderCountsByBuyerId.fulfilled, (state, action) => {
        state.loading = false;

        const updatedCounts = action.payload;
        const defaultFolders = ["Total Suppliers", "Tier 1", "Tier 2"];

        const dynamicFolders = updatedCounts.map((f) => ({
          name: f.folderName,
          numberOfSuppliers: f.total,
          default: defaultFolders.includes(f.folderName),
        }));

        const mergedFolders = [
          {
            name: "Total Suppliers",
            numberOfSuppliers: state.totalSuppliers,
            default: true,
          },
          ...["Tier 1", "Tier 2"].map((tier) => {
            const match = updatedCounts.find((f) => f.folderName === tier);
            return {
              name: tier,
              numberOfSuppliers: match ? match.total : 0,
              default: true,
            };
          }),
          ...dynamicFolders.filter((f) => !defaultFolders.includes(f.name)),
        ];

        state.folders = mergedFolders;
      })

      .addCase(editSupplierById.pending, (state) => {
        state.updateStatus = { loading: true, success: false, error: null };
      })
      .addCase(editSupplierById.fulfilled, (state, action) => {
        const updatedSupplier = action.payload;

        // Update supplier in state
        state.suppliers = state.suppliers.map((supplier) =>
          supplier._id === updatedSupplier._id ? updatedSupplier : supplier
        );

        // Recalculate folder counts
        state.folders = state.folders.map((folder) => ({
          ...folder,
          numberOfSuppliers: countSuppliersByFolder(
            state.suppliers,
            folder.name,
            state.totalSuppliers
          ),
        }));

        state.updateStatus = { loading: false, success: true, error: null };
      })
      .addCase(editSupplierById.rejected, (state, action) => {
        state.updateStatus = {
          loading: false,
          success: false,
          error: action.payload || "Unknown error",
        };
      })
      .addCase(bulkDeleteSuppliers.fulfilled, (state, action) => {
        const { deletedIds } = action.payload;

        const deletedSuppliers = state.suppliers.filter((s) =>
          deletedIds.includes(s._id)
        );

        state.suppliers = state.suppliers.filter(
          (s) => !deletedIds.includes(s._id)
        );

        state.folders = state.folders.map((folder) => {
          const countReduction = deletedSuppliers.filter(
            (s) =>
              folder.name === "Total Suppliers" ||
              folder.name === s.folder?.name
          ).length;

          return {
            ...folder,
            numberOfSuppliers: Math.max(
              (folder.numberOfSuppliers || 0) - countReduction,
              0
            ),
          };
        });
      })

      .addCase(bulkDeleteSuppliers.rejected, (state, action) => {
        state.error = action.payload || "Failed to bulk delete suppliers";
      })
      .addCase(sendRequestMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.messageStatus = null;
      })
      .addCase(sendRequestMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.messageStatus = "success";
      })
      .addCase(sendRequestMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.messageStatus = "error";
      })
      .addCase(fetchPendingSuppliers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingSuppliers = action.payload.data;
        state.totalPendingSuppliers = action.payload.total;
      })
      .addCase(fetchPendingSuppliers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editFolderName.pending, (state) => {
        state.loading = true;
      })
      .addCase(editFolderName.fulfilled, (state, action) => {
        state.loading = false;

        const { folderToEdit, newFolderName } = action.meta.arg;

        const folderIndex = state.folders.findIndex(
          (folder) => folder.name === folderToEdit
        );

        if (folderIndex !== -1) {
          state.folders[folderIndex].name = newFolderName;
        }
      })
      .addCase(editFolderName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteFolder.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFolder.fulfilled, (state, action) => {
        state.loading = false;

        const { folderName } = action.meta.arg;

        state.folders = state.folders.filter(
          (folder) => folder.name !== folderName
        );
      })
      .addCase(deleteFolder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  addSuppliers,
  updateSupplier,
  deleteSupplier,
  setFolders,
  updateFolders,
  updateFolderCounts,
  saveSupplier,
  removeSavedSupplier,
  // setSelectedSupplier,
  // clearSelectedSupplier,
} = suppliersSlice.actions;

export default suppliersSlice.reducer;
